<div *ngIf="report">
    <h2 class="sr-only">Contacts</h2>
    <div class="card">
        <dl class="flex  flex-wrap">
            <div class="flex-auto pl-6 pt-6 flex items-center justify-between pr-6">
                <h2 class="text-xl font-semibold">Contacts</h2>
                <button type="button" (click)="openEditContactModal()" class="text-secondary hover:opacity-90">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-4">
                    <path d="m2.695 14.762-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z" />
                  </svg>
                </button>
            </div>

            <!-- Personal Emails -->
            <div class="flex items-center w-full flex-none gap-x-4 border-t border-violet-50 dark:border-[#3c4377] px-6 pt-4 mt-6">
                <dt class="flex-none">
                  <span class="sr-only">Emails</span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 text-secondary-900 dark:text-white">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                  </svg>
                </dt>
                <dd class="text-sm font-medium leading-6 text-gray-900">
                    <h3 class="text-lg font-[400]">Emails</h3>
                </dd>
            </div>

            <div *ngFor="let email of getEmails(); index as i;" class="mt-2 flex w-full flex-none gap-x-4 px-6">
              <dt class="w-5 max-w-5"></dt>
              <dd class="flex items-center gap-x-2 text-sm leading-6 text-gray-500">
                  <a href="mailto:{{ email  }}" class="underline">{{ email }}</a>
              </dd>
            </div>

            <div [ngClass]="getEmails().length !== 0 ? 'hidden' : '' " class="mt-2 flex w-full flex-none gap-x-4 px-6">
              <dt class="w-5 max-w-5"></dt>
              <dd class="text-sm leading-6 text-gray-400 !font-normal !dark:text-[#91a7ff]">
                No emails found.
              </dd>

            </div>
            <!-- / Emails -->


            <!-- Phones -->
            <div class="flex items-center w-full flex-none gap-x-4 border-t border-violet-50 dark:border-[#3c4377] px-6 pt-4 mt-4">
                <dt class="flex-none">
                  <span class="sr-only">Phone numbers</span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 text-secondary-900 dark:text-white">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                  </svg>
                </dt>
                <dd class="text-sm font-medium leading-6 text-gray-900">
                    <h3 class="text-lg font-[400]">Phone numbers</h3>
                </dd>
                <div [ngClass]="!(isArrayEmpty(phoneNumbers)) ? 'hidden' : ''  ">
                  <!--
                  <svg class="mx-auto animate-spin h-4 w-4 text-primary dark:text-primary-100 " xmlns="http://www.w3.org/2000/svg"
                      fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                      </path>
                  </svg>
                  -->
                  <!--
                  <app-pulse-loading [status]="'loading'" [size]="'size-2'"></app-pulse-loading>
                  -->
                </div>
            </div>

            <div *ngFor="let phoneNumber of phoneNumbers; index as i;" class="mt-2 flex w-full flex-none gap-x-4 px-6">
                <dt *ngIf="!!phoneNumber" class="w-5 max-w-5"></dt>
                <dd class="text-sm leading-6 text-blue-500 !font-normal !dark:text-[#91a7ff]">
                    {{ phoneNumber }}
                </dd>
            </div>

          <!-- Retrieved: offer a paid refresh (re-runs the reveal for newer numbers) -->
          <div *ngIf="phonesRetrieved && !phoneRetrievalInProgress && !phoneUnblockConfirmVisible" class="mt-2 flex w-full flex-none gap-x-4 px-6">
            <dt class="w-5 max-w-5"></dt>
            <dd class="flex items-center gap-x-2 text-sm leading-6">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-gray-400">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
              </svg>
              <a (click)="requestPhoneUnblock()" class="text-blue-500 dark:text-[#91a7ff] underline cursor-pointer">Refresh phone number</a>
            </dd>
          </div>

          <!-- Locked: phone not retrieved yet — offer Unblock (8 credits) -->
          <div *ngIf="phonesLocked && !phoneUnblockConfirmVisible" class="mt-2 flex w-full flex-none gap-x-4 px-6">
            <dt class="w-5 max-w-5"></dt>
            <dd class="flex items-center gap-x-2 text-sm leading-6">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4 text-gray-400">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
              </svg>
              <a (click)="requestPhoneUnblock()" class="text-blue-500 dark:text-[#91a7ff] underline cursor-pointer">Unblock phone number</a>
            </dd>
          </div>

          <!-- Confirmation: inform about the 8-credit cost before retrieving -->
          <div *ngIf="phoneUnblockConfirmVisible" class="mt-2 flex w-full flex-none gap-x-4 px-6">
            <dt class="w-5 max-w-5"></dt>
            <dd class="text-sm leading-6 text-gray-500 dark:text-[#91a7ff]">
              <p *ngIf="!phonesRetrieved">Retrieving the phone number costs <span class="font-semibold">{{ phoneUnblockCost }} credits</span>, deducted only when a number is found. It can take a few minutes — you'll get a notification when it's unblocked.</p>
              <p *ngIf="phonesRetrieved">Refreshing the phone number costs <span class="font-semibold">{{ phoneUnblockCost }} credits</span>, deducted when the refresh delivers — <span class="font-semibold">even if the numbers come back unchanged</span>. If nothing comes back, you're not charged and your current numbers are kept. It can take a few minutes — you'll get a notification when it finishes.</p>
              <div class="mt-2 flex items-center gap-x-3">
                <button type="button" (click)="confirmPhoneUnblock()"
                        class="rounded-md bg-primary px-3 py-1.5 text-sm font-medium text-white hover:opacity-90">
                  {{ phonesRetrieved ? 'Refresh' : 'Unblock' }} for {{ phoneUnblockCost }} credits
                </button>
                <button type="button" (click)="cancelPhoneUnblock()"
                        class="text-sm text-gray-500 dark:text-[#91a7ff] underline">
                  Cancel
                </button>
              </div>
            </dd>
          </div>

          <!-- Pending: reveal requested (this session or server-side), waiting for delivery -->
          <div *ngIf="phoneRetrievalInProgress" class="mt-2 flex w-full flex-none gap-x-4 px-6">
            <dt class="w-5 max-w-5"></dt>
            <dd class="flex items-center gap-x-2 text-sm leading-6 text-gray-400 !font-normal !dark:text-[#91a7ff]">
              <svg class="animate-spin h-4 w-4 text-primary dark:text-primary-100" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ phonesRetrieved ? 'Refreshing' : 'Retrieving' }} phone number…
            </dd>
          </div>

          <!-- Retrieved, but no number exists for this person -->
          <div *ngIf="!phonesLocked && !phoneRetrievalInProgress && phoneNumbers?.length === 0" class="mt-2 flex w-full flex-none gap-x-4 px-6">
            <dt class="w-5 max-w-5"></dt>
            <dd class="text-sm leading-6 text-gray-400 !font-normal !dark:text-[#91a7ff]">
              No phone numbers found.
            </dd>
          </div>
            <!-- / Phones -->

            <!-- Social profiles -->
            <div class="flex items-center  w-full flex-none gap-x-4 border-t border-violet-50 dark:border-[#3c4377] px-6 pt-4 mt-4">
                <dt class="flex-none w-5 max-w-5">
                  <span class="sr-only">Social profiles</span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5 text-secondary-900 dark:text-white">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
                  </svg>
                </dt>
                <dd class="text-sm font-medium leading-6 text-gray-900">
                    <h3 class="text-lg font-[400]">Social profiles</h3>
                </dd>
            </div>

            <!-- Facebook URL -->
            <div *ngIf="facebookURL" class="flex items-center mt-2 w-full  gap-x-4 px-6">
              <dt class="w-5 max-w-5">
                <svg class="h-5 w-5 fill-[#0b66c2]" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill-rule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clip-rule="evenodd"></path>
                </svg>
              </dt>
              <dd class="text-sm leading-6 text-gray-500">
                <a href="{{ facebookURL }}" target="_blank" class="text-blue-500 dark:text-[#91a7ff] underline break-all">{{ facebookURL }}</a>
              </dd>
            </div>

            <!-- Linkedin URL -->
            <div *ngIf="linkedinURL" class="flex items-center mt-2 w-full gap-x-4 px-6">
                <dt class="w-5 max-w-5">
                  <svg viewBox="0 0 14 13" fill="none" class="h-5 w-5 fill-[#0b66c2]">
                      <path d="M12.25 0.625C12.7148 0.625 13.125 1.03516 13.125 1.52734V12C13.125 12.4922 12.7148 12.875 12.25 12.875H1.72266C1.25781 12.875 0.875 12.4922 0.875 12V1.52734C0.875 1.03516 1.25781 0.625 1.72266 0.625H12.25ZM4.56641 11.125V5.30078H2.76172V11.125H4.56641ZM3.66406 4.48047C4.23828 4.48047 4.70312 4.01562 4.70312 3.44141C4.70312 2.86719 4.23828 2.375 3.66406 2.375C3.0625 2.375 2.59766 2.86719 2.59766 3.44141C2.59766 4.01562 3.0625 4.48047 3.66406 4.48047ZM11.375 11.125V7.92578C11.375 6.36719 11.0195 5.13672 9.1875 5.13672C8.3125 5.13672 7.71094 5.62891 7.46484 6.09375H7.4375V5.30078H5.71484V11.125H7.51953V8.25391C7.51953 7.48828 7.65625 6.75 8.61328 6.75C9.54297 6.75 9.54297 7.625 9.54297 8.28125V11.125H11.375Z" />
                  </svg>
                </dt>
                <dd class="text-sm leading-6 text-gray-500">
                    <a href="{{ linkedinURL }}" target="_blank" class="text-blue-500 dark:text-[#91a7ff] underline break-all">{{ linkedinURL }}</a>
                </dd>
            </div>
            <!-- / Social profiles -->

        </dl>
        <div class="pb-6"></div>
    </div>

</div>
